import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'projectUploads',
  urlRoot: '/project_uploads',
  getters: {
    byProject: (state) => (id) => {
      return Object.values(state.entities).filter(projectUpload => projectUpload.project === '/projects/' + id)
    }
  }
})
